<template>
  <div class="rating-info-container">
    <div class="company-container">
      <span class="iconfont iconcompany"></span>
      <span class="content company-name" :title="companyName"> {{ companyName }} </span>
      <img class="company-logo" :src="$DjangoMediaUrl(dataInfo.company.logo)">
    </div>
    <div class="company-container">
      <span class="iconfont icona-jobname"></span>
      <span class="content job-title"> {{ jobTitle }} </span>
    </div>
    <div class="company-container">
      <span class="iconfont iconcandidate"></span>
      <span class="content candidate-name"> {{ dataInfo.candidate.name }} </span>
    </div>
  </div>
</template>

<script>
import { getI18nPropertyValue } from '@/i18n'

export default {
  components: {
  },
  props: {
    dataInfo: {
      require: true
    },
    isPC: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    companyName () {
      return getI18nPropertyValue(this.dataInfo?.company, 'cn_name', 'name') || ''
    },
    jobTitle () {
      return getI18nPropertyValue(this.dataInfo?.job, 'cn_title', 'title') || ''
    }
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.rating-info-container {
  background: #FFFFFF;
  margin: 0 15px 10px 15px;
  padding: 15px 10px;

  &> div {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 12px;

    .clear-bottom {
      padding-bottom: 0;
    }

    &:last-child {
      margin-bottom: 0;
      .icon {
        &::after {
          display: none;
        }
      }
    }

    .company-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      width: 65%;
    }
  }

  .iconfont {
    color: #b5b4b4;
    font-size: 28px;
  }

  .company-logo {
    position: absolute;
    right: 20px;
    width: 50px;
    top: 0px;
  }

  .content {
    margin-left: 5px;
    color: #000000;
    font-weight: 600;
    margin-top: 1px
  }

}
</style>
